import * as types from '../mutation-types';
import balance from '../../api/balance';

const state = {
  balances: [],
  pagination: null,
};

const getters = {};

const actions = {
  fetchBalances({ commit }, params) {
    return balance.get(params).then(({ data: response }) => {
      commit(types.RECEIVE_BALANCES, { data: response });
    });
  },
};

/* eslint no-param-reassign: 0 */
const mutations = {
  [types.RECEIVE_BALANCES](s, { data }) {
    s.balances = [...data.data];
    s.pagination = data.meta.pagination;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/balance.js